(function() {
  var store;
  var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
  store = window.Store || (window.Store = {});
  store.Views = store.Views || (store.Views = {});
  store.Views.CollectionView = Backbone.View.extend({
    initialize: function(options) {
      this.appModel = options.appModel;
      this.interval = setInterval(__bind(function() {
        this.rotateImages();
      }, this), 3000);
      this.appModel = store.Main.appModel;
      this.appModel.bind('state-change', __bind(function() {
        this.destroy();
      }, this));
    },
    rotateImages: function() {
      this.appModel.trigger('collection-image-fade');
    },
    destroy: function(e) {
      clearInterval(this.interval);
      this === {};
    }
  });
}).call(this);
